import React from 'react';

import { CopyToClipboardButton } from 'ui-components/components/copy-to-clipboard-button/copy-to-clipboard-button';

import { CellPropTypes } from '../../../../prop-types/react-table';
import { messages } from './messages';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

export const CopyToClipboardCell = ({ value }) => {
  return <CopyToClipboardButton textToCopy={String(value)} tooltipMessageDescriptor={messages.copyToClipboardButtonLabel} />;
};

CopyToClipboardCell.propTypes = CellPropTypes;

export const createCopyToClipboardColumnDefinition = createColumnDefinitionBuilder({
  id: 'copyToClipboard',
  Cell: CopyToClipboardCell,
  canResize: false,
  width: 64, // in px since canResize is false
});
